import React from 'react';
import './TechnologiesSection.css';
import TechIcon from '../TechIcon';

const TechnologiesSection = () => {
  // Main technologies to showcase
  const mainTechnologies = [
    // Programming Languages
    'JavaScript',
    'TypeScript',
    'Python',
    'HTML5',
    'CSS3',
    
    // Frontend Frameworks/Libraries
    'Nextjs',
    'React',
    'Django',
    'Supabase',
    'Redux',
    'React Router',
    'React Query',
    'Material-UI',
    'TailwindCSS',
    'Bootstrap',
    'Framer Motion',
    
    // Backend Technologies
    // 'Node.js',
    // 'Express',
    // 'Flask',
    
    // Databases
    // 'MongoDB',
    // 'PostgreSQL',
    // 'SQLite',
    // 'MySQL',
    
    // Tools & Others
    'Git',
    'Vite',
    // 'Vercel',
    // 'Netlify'
  ];

  return (
    <div className="technologies-section">
      <div className="technologies-container">
        <h2 className="technologies-title">My Tech Stack</h2>
        <p className="technologies-subtitle">Technologies I've been working with</p>
        
        <div className="technologies-grid">
          {mainTechnologies.map((tech, index) => (
            <div className="technology-item" key={index}>
              <TechIcon name={tech} size={48} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TechnologiesSection; 